import styled from '@emotion/styled';

export const Wrapper = styled.div(({ theme }) => ({
    marginTop: theme.space[8],
    paddingBottom: theme.space[6],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.space[5],
}));

export const Section = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.space[4],

    '& + &': {
        marginTop: theme.space[6],
    },
}));

export const Entry = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.space[1],
}));
